import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Trusts & Legal Entities',
		url: '/legal_entities',
		icon: 'handshake-o',
	}
];

export default class LegalEntity extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.trust = false;
	}

	updateNameType = (name, trust) => {
		if (this.state.name !== name) {
			this.setState({name: name});
		}
		if (this.state.trust !== trust) {
			this.setState({trust: trust});
		}
	};

	render() {
		let {trust} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/legal_entities/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{trust &&
					<Objects.LegalEntityTrustee
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label={trust ? "Trust" : "Legal Entity"} value="details"/>
					{trust && <Tab label="Trustees" value="trustees"/>}
					<Tab label="Change Log" value="logs"/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.LegalEntity
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateNameType={this.updateNameType}
						type={"Legal_Entities"}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{this.state.tab === 'trustees' &&
				<Collections.Trustees
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' &&
				<Collections.LogsLegalEntities
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		)
	}
};
